import { Banner, FlexContainer, Icon, Sizes, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { PueblaPreviousYearsResponse } from 'Services/sat/types';
import { useTranslation } from 'Hooks/useTranslation';
import MandatoryInfo from 'Containers/Result/components/MandatoryInfo';
import { ResultType } from 'Types/common';

const FlexsUsersResult = ({
  daInfo,
  pyInfo,
}: {
  daInfo: ResultType;
  pyInfo: PueblaPreviousYearsResponse;
}): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  const totalAmountToRecovery = Math.abs(daInfo?.taxReturnResult) + Math.abs(pyInfo?.amountPending);

  return (
    <FlexContainer direction="column" align="center" justify="center" gap="dimension_24">
      {daInfo.mandatory && <MandatoryInfo daInfo={daInfo} />}
      <FlexContainer direction="column" gap="dimension_16">
        <Text type="paragraphs" align="center" size="L_XL_S" color="dark">
          {t('Flexs.da.result.title')}
        </Text>
        <Text type="paragraphs" align="center" size="M_L_S" color="dark">
          {t('Flexs.da.result.subtitle')}
        </Text>
        <FlexContainer fullWidth align="center" justify="center" gap="dimension_16">
          <Icon icon="ShineL" color="warning" />
          <Text type="headline" size="S_L_S" color="fresh">
            {YayoyakiFormatter.formatAmountMxn(Math.abs(totalAmountToRecovery))}
          </Text>
          <Icon icon="ShineL" color="warning" />
        </FlexContainer>
      </FlexContainer>
      <FlexContainer direction="column" gap="dimension_16">
        <FlexContainer direction="column" align="center" justify="center" gap="dimension_08">
          <Text type="paragraphs" align="center" size="XS_M_S" color="grey">
            {t('Flexs.da.result.info')}
          </Text>
          <FlexContainer gap="dimension_08" align="center">
            <Text type="paragraphs" size="S_L_S" color="dark">
              {t('Flexs.da.result')}
            </Text>
            <Text type="paragraphs" size="M_L_S" color="fresh">
              {YayoyakiFormatter.formatAmountMxn(Math.abs(daInfo?.taxReturnResult))}
            </Text>
          </FlexContainer>
          <FlexContainer gap="dimension_08" align="center">
            <Text type="paragraphs" size="S_L_S" color="dark">
              {t('Flexs.aa.result.amount')}
            </Text>
            <Text type="paragraphs" size="M_L_S" color="fresh">
              {YayoyakiFormatter.formatAmountMxn(Math.abs(pyInfo?.amountPending))}
            </Text>
          </FlexContainer>
        </FlexContainer>
        <Banner
          id="da-info"
          mode="default"
          hasIcon={false}
          position="vertically"
          label={t('Flexs.info.aa.title')}
          description={t('Flexs.info.aa.description')}
          layout="embed"
          titleSize={Sizes.S}
          size={Sizes.M}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default FlexsUsersResult;
